const styles = {
  wrapper: {
    padding: `0 25px`
  },
  box: {
    padding: `20px`,
    border: `1px solid #666`,
    borderRadius: `3px`
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/Statistics/style/ColorBlind/graph.js